import {config as dateColumnConfig} from '../../common/DateColumn';

export const prop = 'sD';

export const config = (labels) => dateColumnConfig({id: 'start', label: labels.start, prop});
